<template>
  <div class="begin">
    <div class="top">
      <div class="wrap">

        <div class="bos a">{{$t('New alarms count')}}: {{newAlarmsCnt}}</div>

        <div class="bos selectors-block">
          <div>
            <label>{{$t('sort-by')}}:</label>
            <select name="sort" v-model="sortOrder" class="sort" >
              <option value=null>{{$t('Select')}}</option>
              <option value="name">{{$t('Name')}}</option>
              <option value="risk">{{$t('Risk')}}</option>
              <option value="alarms">{{$t('Alarm')}}</option>
            </select>
          </div>

          <div>
            <label>{{$t('show-only')}}:</label>
            <select name="show" v-model="filter" class="show" >
              <option value="everyone">{{$t('Everyone')}}</option>
              <option value="high_risk">{{$t('high-risk-patients')}}</option>
              <option value="with_alarms">{{$t('patients-with-alarm')}}</option>
            </select>
          </div>
        </div>

        <div class="bos d">
          <button v-if="user.features.addPatient" class="full-height" @click="showModal({componentName: 'PatientInfo', modalTitle: $t('patient-settings'), modalData: {activeTab: 5}})">{{$t('Add new patient')}}</button>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="card">
        <!-- displays loading screen if loading -->
        <div v-if="loading" class="loading">
          <LoadingScreen  />
        </div>
        <PatientBlock v-else v-for="(patient) in patients" :key="patient.id" :patient="patient"></PatientBlock>
      </div>
    </div>
  </div>
</template>

<script>
import PatientBlock from './PatientBlock'
import LoadingScreen from './LoadingScreen'
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'ActivePatients',
  data() {
    return {
      sortOrder: null,
      filter: process.env.VUE_APP_UI_SETTINGS_MAIN_VIEW || 'everyone',
      loading: false
    }
  },
  components: {
    PatientBlock,
    LoadingScreen
  },
  computed: {
    patients() {
      return this.sortPatients(this.filterPatients(this.activePatients))
    },
    newAlarmsCnt() {
      return this.patients.reduce((total, patient) => {
        return total + this.getUnwatchedAlarmsCnt(patient)
      }, 0)
    },
    ...mapState([
      'activePatients', 'user',
    ])
  },
  methods: {
    getUnwatchedAlarmsCnt(patient) {
      return patient.medicalData ? parseInt(patient.medicalData.unwatchedAlarmsCnt) || 0 : 0
    },
    sortPatients(patients) {
      console.log('Sort patients', this.sortOrder)
      switch (this.sortOrder) {
        case 'name':
          patients = patients.sort((a, b) => { return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1 })
          break
        case 'risk':
          patients = patients.sort((a, b) => { return b.risk < a.risk ? -1 : 1 })
          break
        case 'alarms':
          patients = patients.sort((a, b) => {
            return this.getUnwatchedAlarmsCnt(b) - this.getUnwatchedAlarmsCnt(a)
          })
          break
        default:
          patients = patients.sort((a, b) => { return b.created < a.created ? -1 : 1 })
          break
      }
      return patients
    },
    filterPatients(patients) {
      switch (this.filter) {
        case 'high_risk':
          patients = patients.filter(patient => patient.risk >= 3)
          break
        case 'with_alarms':
          patients = patients.filter(patient => parseInt((patient.medicalData && patient.medicalData.unwatchedAlarmsCnt) || 0) > 0)
          break
      }
      return patients
    },
    ...mapMutations(['showModal'])
  },
  mounted() {

  }
}
</script>

<style scoped>
  .selectors-block {
    display: flex;
    justify-items: center;
  }
  .selectors-block > div {
    width: 50%;
    margin: 0 auto;
  }
  .selectors-block label {
    display: block;
  }
  .selectors-block select {
    width: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ActivePatients.vue